import { useCallback, useEffect, useRef, useState } from 'react';
import { breakpoints, useBreakpoint } from 'app/spacing';
import Button from 'components/Button';
import { PageContentContainer } from 'components/Layout/PageContentWidth';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Body, Header, StyledCard } from './styles';
import FileService from 'services/FileService';
import { useDispatch } from 'react-redux';
import { setError } from 'store/errors';

const DownloadFilePage = () => {
  const { t } = useTranslation();
  const { id: fileId } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const downloaded = useRef(false);
  const isMobile = useBreakpoint(breakpoints.sm);

  const downloadFile = useCallback(async () => {
    if (fileId) {
      setLoading(true);
      try {
        // first try and get the file from the public endpoint
        await FileService.getPublicFile(fileId);

        // if that worked then we can download the file
        const tempLink = document.createElement('a');
        tempLink.href = `${import.meta.env.VITE_API_BASE_PATH}/files/${fileId}/download?disposition=attachment`;
        tempLink.download = true;
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
      } catch (err) {
        dispatch(setError({ code: 404 }));
      } finally {
        setLoading(false);
      }
    }
  }, [fileId, dispatch]);

  useEffect(() => {
    if (!downloaded.current) {
      downloadFile();
      downloaded.current = true;
    }
  }, [downloadFile]);

  return (
    <PageContentContainer>
      <StyledCard mobile={isMobile}>
        <Header
          as="h1"
          type={isMobile ? 'subheader' : 'hero'}
          mobile={isMobile}
        >
          {t('Your File is Ready for Download')}
        </Header>
        <Body as="p" mobile={isMobile}>
          {t(
            'If the download does not begin automatically, please click the button below'
          )}
          .
        </Body>

        <Button
          onClick={downloadFile}
          color="blue"
          preventDefault={false}
          disabled={loading}
        >
          {t('Download Now')}
        </Button>
      </StyledCard>
    </PageContentContainer>
  );
};

export default DownloadFilePage;
